import { useEffect } from 'react';
import useHasAcknowledgedTerms from '../useHasAcknowledgedTerms';
import useModal from 'src/components/Modals/hooks/useModal';
import useWalletIsConnected from '../useWalletIsConnected';

export const useOnboardingFlowControl = () => {
	const connected = useWalletIsConnected();
	const [hasAcknowledgedTerms] = useHasAcknowledgedTerms();
	const { currentModal, show } = useModal();

	useEffect(() => {
		if (!connected) {
			return;
		}

		if (currentModal?.type === 'connect_wallet') {
			return;
		}

		const shouldShowTerms = hasAcknowledgedTerms.shouldShowTermsReminder;

		if (shouldShowTerms && currentModal?.type !== 'terms_of_use') {
			show({ type: 'terms_of_use', props: {} });
		}
	}, [
		connected,
		hasAcknowledgedTerms.shouldShowTermsReminder,
		currentModal?.type,
		show,
	]);
};
